import { useState } from 'react'

import { AnimateBox } from '../../components/animate-box'

import type { SolutionTag } from '../../pageContents'

interface SectionBProps {
  data: SolutionTag[]
  title: string
}
export const SectionB = ({ data, title }: SectionBProps) => {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <>
      <div className='title-box'>
        <AnimateBox tagName='h2'>{title}</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          基于MBSE正向设计理念，研发GCKontrol-GCAir基于模型的系统设计工具链，面向复杂装备研发与运维形成了控制系统开发、数字孪生研发、半实物虚实仿真、数字孪生运维等方案，为复杂装备正向设计提供了工具支撑，为数字孪生技术的落地提供了解决方案。
        </AnimateBox>
      </div>
      <ul className='wrap'>
        {data.map((item, index) => {
          const { thumbnail } = item
          const key = index + '1'
          const classArr = ['card', 'border', 'h600']
          if (index === activeIndex) {
            classArr.push('w550')
          } else {
            classArr.push('w270')
          }
          classArr.push('p335-180')

          return (
            <AnimateBox
              animateDelay={(index % 4) * 0.2}
              className={classArr.join(' ')}
              key={key}
              style={{
                animationDelay: `${1 + index * 0.2}s`
              }}
              onMouseEnter={() => {
                setActiveIndex(index)
              }}
            >
              <div className='img h348'>
                <div className='pic' style={{ backgroundImage: `url(${thumbnail})` }} />
              </div>
              <div className='info'>
                <h5 className='clamp-2'>
                  <a href={`/solution/${item.id}`}>{item.name}</a>
                </h5>
                <p className='clamp-2'>{item.descriptions}</p>
                <a className='look-more' href={`/solution/${item.id}`}>
                  了解更多
                </a>
              </div>
            </AnimateBox>
          )
        })}
      </ul>
    </>
  )
}
